import React from 'react';
import { AutoComplete as AntdAutoComplete } from 'antd';
import { AutoCompleteProps as AntdAutoCompleteProps } from 'antd/lib/auto-complete';
import type { RefSelectProps } from 'antd/lib/select';
import classnames from 'classnames';
import { Input, InputProps } from '../Input';
import autocompleteCn from './styles.module.scss';

export interface AutoCompleteProps extends AntdAutoCompleteProps {
  inputProps?: InputProps,
}

const DEFAULT_INPUT_PROPS = {};

export const AutoComplete = React.forwardRef<RefSelectProps, AutoCompleteProps>(({
  className,
  onChange,
  value,
  inputProps = DEFAULT_INPUT_PROPS,
  ...props
}, ref) => (
  <AntdAutoComplete
    ref={ref}
    onChange={onChange}
    value={value}
    className={classnames(autocompleteCn.autocomplete, className)}
    {...props}
  >
    <Input {...inputProps} />
  </AntdAutoComplete>
));

AutoComplete.displayName = 'AutoComplete';
